"use client";

import { c as _c } from "react/compiler-runtime";
import { Spinner, Toast, ToastAvatar, ToastContent, ToastErrorIcon, ToastSide, ToastSuccessIcon, ToastTitle, useToasts } from "@opensea/ui-kit";
import { useEffect, useMemo, useRef } from "react";
import { useTranslations } from "use-intl";
import { useTransactionStatus } from "../../../polychain/hooks/useTransactionStatus";
import { useRenderImage } from "../../../providers/RenderImageProvider";
import { FlowActions } from "../../../stores/flowStore";
export function TokenClaimToast(t0) {
  const $ = _c(42);
  const {
    tokenReward,
    transactionIdentifier
  } = t0;
  const t = useTranslations("wallet.TokenClaimToast");
  const {
    renderImage
  } = useRenderImage();
  const {
    removeToast
  } = useToasts();
  const hasCalledOnSuccess = useRef(false);
  let t1;
  if ($[0] !== transactionIdentifier.chain || $[1] !== transactionIdentifier.transactionHash) {
    t1 = {
      transaction: {
        chain: transactionIdentifier.chain,
        hash: transactionIdentifier.transactionHash
      }
    };
    $[0] = transactionIdentifier.chain;
    $[1] = transactionIdentifier.transactionHash;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const transactionStatus = useTransactionStatus(t1);
  let t2;
  let t3;
  if ($[3] !== transactionStatus) {
    t2 = () => {
      if (transactionStatus === "success" && !hasCalledOnSuccess.current) {
        hasCalledOnSuccess.current = true;
        FlowActions.onSuccess();
      }
    };
    t3 = [transactionStatus];
    $[3] = transactionStatus;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[6] !== removeToast || $[7] !== transactionStatus) {
    t4 = () => {
      if (transactionStatus === "success" || transactionStatus === "error") {
        const timerId = setTimeout(() => {
          removeToast("token-claim-toast");
        }, transactionStatus === "error" ? 4000 : 1500);
        return () => clearTimeout(timerId);
      }
    };
    t5 = [transactionStatus, removeToast];
    $[6] = removeToast;
    $[7] = transactionStatus;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  tokenReward.balance?.currency?.imageUrl;
  let t6;
  t6 = tokenReward.balance?.currency?.imageUrl || null;
  const tokenImageUrl = t6;
  let t7;
  bb0: switch (transactionStatus) {
    case "pending":
      {
        let t8;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
          t8 = <Spinner size="sm" />;
          $[10] = t8;
        } else {
          t8 = $[10];
        }
        let t9;
        if ($[11] !== t) {
          t9 = t("claimPending");
          $[11] = t;
          $[12] = t9;
        } else {
          t9 = $[12];
        }
        let t10;
        if ($[13] !== t9) {
          t10 = {
            icon: t8,
            title: t9
          };
          $[13] = t9;
          $[14] = t10;
        } else {
          t10 = $[14];
        }
        t7 = t10;
        break bb0;
      }
    case "error":
      {
        let t8;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
          t8 = <ToastErrorIcon />;
          $[15] = t8;
        } else {
          t8 = $[15];
        }
        let t9;
        if ($[16] !== t) {
          t9 = t("claimFailed");
          $[16] = t;
          $[17] = t9;
        } else {
          t9 = $[17];
        }
        let t10;
        if ($[18] !== t9) {
          t10 = {
            icon: t8,
            title: t9
          };
          $[18] = t9;
          $[19] = t10;
        } else {
          t10 = $[19];
        }
        t7 = t10;
        break bb0;
      }
    case "success":
      {
        let t8;
        if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
          t8 = <ToastSuccessIcon />;
          $[20] = t8;
        } else {
          t8 = $[20];
        }
        let t9;
        if ($[21] !== t) {
          t9 = t("claimSuccessful");
          $[21] = t;
          $[22] = t9;
        } else {
          t9 = $[22];
        }
        let t10;
        if ($[23] !== t9) {
          t10 = {
            icon: t8,
            title: t9
          };
          $[23] = t9;
          $[24] = t10;
        } else {
          t10 = $[24];
        }
        t7 = t10;
        break bb0;
      }
    default:
      {
        let t8;
        if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
          t8 = <Spinner size="sm" />;
          $[25] = t8;
        } else {
          t8 = $[25];
        }
        let t9;
        if ($[26] !== t) {
          t9 = t("claimPending");
          $[26] = t;
          $[27] = t9;
        } else {
          t9 = $[27];
        }
        let t10;
        if ($[28] !== t9) {
          t10 = {
            icon: t8,
            title: t9
          };
          $[28] = t9;
          $[29] = t10;
        } else {
          t10 = $[29];
        }
        t7 = t10;
      }
  }
  const {
    icon,
    title
  } = t7;
  const t8 = `${tokenReward.balance?.currency?.chainIdentifier}:${tokenReward.balance?.currency?.contractAddress}`;
  const t9 = tokenImageUrl || "";
  let t10;
  if ($[30] !== renderImage || $[31] !== t8 || $[32] !== t9) {
    t10 = <ToastAvatar renderImage={renderImage} seed={t8} src={t9} />;
    $[30] = renderImage;
    $[31] = t8;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== title) {
    t11 = <ToastContent><ToastTitle>{title}</ToastTitle></ToastContent>;
    $[34] = title;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== icon) {
    t12 = <ToastSide>{icon}</ToastSide>;
    $[36] = icon;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== t10 || $[39] !== t11 || $[40] !== t12) {
    t13 = <Toast>{t10}{t11}{t12}</Toast>;
    $[38] = t10;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  return t13;
}